import { Dictionary, isEmpty } from "lodash";
import { JSX, useState } from "react";

import { notify } from "../../components/shared/basic/notify";
import { formatErrorObject, setToken } from "../../utils/lib/auth";

import { useNavigate } from "react-router-dom";
import apiClient from "../../services/base";
import { Endpoints } from "../../network";
import Cookies from "js-cookie";
import { useRecoilState } from "recoil";
import { AppwriteUserData, UserData } from "../../utils/interfaces/user";
import { user } from "../../atoms/toggleTheme/user";
import { tokenUpdate } from "../../atoms/authModalControl";
import appwriteService, { setTokenInCookies } from "../../config/appwrite";
import { formateErrorAppwriteObject } from "../../components/shared/basic/formateError";
import authorToolApiClient from "../../services/authorToolBase";

export const useLogin = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [, setUserData] = useRecoilState<UserData | undefined>(user);
  const [, setIsTokenChanged] = useRecoilState(tokenUpdate);

  const router = useNavigate();

  const handleAssignAffiliate = async () => {
    try {
      await apiClient.get(Endpoints.affiliateCheck);
    } catch (error: any) {
      const message = formateErrorAppwriteObject(error);
      notify(message, "error");
    }
  };

  const onLogin = async (
    email: string,
    password: string
  ): Promise<Dictionary<string | JSX.Element>> => {
    setLoading(true);
    const errorMessages: Dictionary<JSX.Element | string> = {};

    let notificationSent = false;

    try {
      await appwriteService.logoutIfSessionExists();
      const response = await appwriteService.login({
        email,
        password,
      });

      const token = await setTokenInCookies();
      let currentUser: AppwriteUserData | undefined = undefined;

      if (response) {
        const user = await appwriteService.getCurrentUser();
        if (user !== null) {
          currentUser = user as unknown as AppwriteUserData;
        }
      }
      const dbUser: UserData = await appWriteUser(currentUser?.$id as string);

      await setToken(token);
      setIsTokenChanged(true);

      if (isEmpty(dbUser)) {
        throw Error();
      }

      await handleAssignAffiliate();

      setUserData(dbUser);

      if (isEmpty(dbUser)) {
        throw Error();
      } else {
        Cookies.set("user_id", dbUser.id as string);

        if (!notificationSent) {
          notify("Successfully Logged IN!", "success");
          notificationSent = true;
        }
      }
      router("/dashboard");
    } catch (error: any) {
      const message = formateErrorAppwriteObject(error);

      if (!notificationSent) {
        notify(message, "error");
        notificationSent = true;
      }
    } finally {
      setLoading(false);
    }
    return errorMessages;
  };

  return { loading, onLogin };
};
export const appWriteUser = async (zl_uid: string) => {
  try {
    const response = await apiClient.post(Endpoints.appWriteUser, { zl_uid });
    await authorToolApiClient.post(Endpoints.appWriteUserAuthorTool, {
      zl_uid,
    });

    return response?.data?.data;
  } catch (error: any) {
    const message = formatErrorObject(error);

    console.log(message);
  }
};
